export default __webpack_public_path__ + "static/media/twitch.47b1076a.svg";